import React, {Component} from "react";
import PropTypes from "prop-types";
import "../../styles/PaySlipFormStyles.css";
import i18next from "i18next";

class PaySlipFormBaltika extends Component {
    constructor(props, context) {
        super(props, context);

        this.headersHdr = this.props.headerDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});

        this.headersTab = this.props.tableDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});
    }

    getHeader = (name, area = 'header') => {
        let source = area === 'table' ? this.headersTab : this.headersHdr;
        if (source && source[name]) {
            return source[name].replace("|", " ");
        }
    };

    getMoneyValue = (value) => {
        const nf = new Intl.NumberFormat( {maximumFractionDigits:2});
        return value ? nf.format(value) : <>&nbsp;</>
    }


    renderHeaderInfo = (level1Info) => {
        return (
            <div id="paySlip_header">
                <h3>{i18next.t('PaySlip')}</h3>
                <table id="paySlip_header1" cellPadding="3">
                    <tbody>
                    <tr>
                        <td>{i18next.t('PaySlip_7')}</td>
                        <td className="paySlip_mn-report-value">{this.props.monthName}</td>
                        {/*<td className="paySlip_mn-report-value">{level1Info.CalcMonth}</td>*/}
                    </tr>
                    <tr>
                        <td>{this.getHeader("FioTn")}:</td>
                        <td className="paySlip_mn-report-value">{level1Info.FioTn}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("AsCodeName")}:</td>
                        <td className="paySlip_mn-report-value">{level1Info.AsCodeName}</td>
                    </tr>
                    </tbody>
                </table>
                <table id="header2" cellPadding="3">
                    <tbody>
                    <tr>
                        <td>{this.getHeader("SumPNDbt")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.SumPNDbt)}</td>
                        <td>{this.getHeader("BegSaldo")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldo)}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("SumPNVal")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.SumPNVal)}</td>
                        <td>{this.getHeader("EndSaldo")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldo)}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    };

    renderReportInfo = (level1Info, level2Info) => {
        return (
            <>
                <table id="paySlip_main" cellPadding="3px" className="w-100">
                    <thead>
                    <tr>
                        <th className="w-50px">{this.getHeader("DbtMonth", "table")}</th>
                        <th className="w-50px">{this.getHeader("DbtDayTime", "table")}</th>
                        <th className="w-50px">{this.getHeader("DbtCode", "table")}</th>
                        <th>{this.getHeader("DbtName", "table")}</th>
                        <th>{this.getHeader("DbtSum", "table")}</th>
                        <th className="w-auto border-bottom-0"></th>
                        <th className="w-50px">{this.getHeader("CrdCode", "table")}</th>
                        <th>{this.getHeader("CrdName", "table")}</th>
                        <th>{this.getHeader("CrdSum", "table")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        level2Info.map((item, i) => (
                            <tr key={i}>
                                <td>{item.DbtMonth}</td>
                                <td>{item.DbtDayTime}</td>
                                <td>{item.DbtCode}</td>
                                <td className="text-left">{item.DbtName}</td>
                                <td>{this.getMoneyValue(item.DbtSum)}</td>
                                <td className="border-top-0 border-bottom-0"></td>
                                <td>{item.CrdCode}</td>
                                <td className="text-left">{item.CrdName}</td>
                                <td>{this.getMoneyValue(item.CrdSum)}</td>
                            </tr>
                        ))
                    }

                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan="4" className="text-right border-0 font-weight-bold">{this.getHeader("AllDbtSum")}:</td>
                        <td className="w-auto border-0 font-weight-bold">{this.getMoneyValue(level1Info.AllDbtSum)}</td>
                        <td className="border-top-0 border-bottom-0"></td>
                        <td colSpan="2" className="text-right border-0 font-weight-bold">{this.getHeader("AllCrdSum")}:</td>
                        <td className="w-auto border-0 font-weight-bold">{this.getMoneyValue(level1Info.AllCrdSum)}</td>
                    </tr>
                    </tfoot>
                </table>

                {this.renderFooterInfo(level1Info)}
            </>
        );
    };

    renderFooterInfo = (level1Info) => {
        return (
            <table id="paySlip_footer">
                <tbody>
                <tr>
                    <td>{this.getHeader("Cash")}:</td>
                    <td width="50px" className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Cash)}</td>
                </tr>
                <tr>
                    <td>{this.getHeader("Card")}:</td>
                    <td width="50px" className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Card)}</td>
                </tr>
                <tr>
                    <td>{this.getHeader("Bank")}:</td>
                    <td width="50px" className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Bank)}</td>
                </tr>
                </tbody>
            </table>
        );
    };

    render() {
        if (this.props.headerDataItem.dataTable().length === 0) {
            return null;
        }

        let level1Info = this.props.headerDataItem.getRow(0);
        let level2Info = this.props.tableDataItem.dataTable();

        return (
            <div id="paySlip_report">
                <div>{level1Info.MyComp}</div>
                {this.renderHeaderInfo(level1Info)}
                {this.renderReportInfo(level1Info, level2Info)}
            </div>
        );
    }
}

PaySlipFormBaltika.propTypes = {
    headerDataItem: PropTypes.object.isRequired,
    tableDataItem: PropTypes.object.isRequired,
    monthName: PropTypes.string
};

PaySlipFormBaltika.defaultProps = {
    monthName: ""
};

export default PaySlipFormBaltika;
